import styled from 'styled-components';

export const HeaderS = styled.div`
  position: relative;
  /* background: #1890ff; */
  /* min-height: 50px; */
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  padding: 19px 20px;
  background: #1890ff;
  color: #fff; */
`;

export const BodyS = styled.div`
  padding: 10px 20px 20px;
  flex: 1;
  overflow: auto;
`;

export const SubInfoS = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  display: flex;
  align-items: center;
`;
